import React, { useState, useLayoutEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';


import Page from '../layouts/Page';
import services from '../services';

const PrivateRoutes = ({ component: Component, ...rest }) => {
    const [resultadoPesquisar, setResultadoPesquisar] = useState();
    const user = services.storage.getUser();
    const IsAdmin = user ? user.IsAdmin : undefined;
    const routers = ['/home', '/home-banners', '/configuracoes', '/dashboard', '/log', '/usuario'];
    const search = (value) => {
        if (value.length > 0) {
            setResultadoPesquisar(value);
        }
    }

    return (
        <div>
            {(IsAdmin === 'False' && routers.some((router) => rest.path.startsWith(router))
                ? (<Redirect to={{ pathname: '/galeria-midia' }} />)
                : (<Route {...rest} render={props => {
                    const isAuthenticated = services.storage.get('isAuthenticated');
                    const hasToken = sessionStorage.getItem('authSistema');
                    
                    if (isAuthenticated && hasToken) {
                        return <Page search={search}> <Component {...props} resultadoPesquisar={resultadoPesquisar} />  </Page>;
                    } else {
                        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
                    }
                }} />))
            }

        </div>

    )
}

export default PrivateRoutes;
